import iconMapLegendInjury from '../img/icons/map/legend/injury.svg';
import iconMapLegendMemorial from '../img/icons/map/legend/memorial.svg';
import iconMapLegendProjects from '../img/icons/map/legend/projects.svg';
import iconMapLegendSafety from '../img/icons/map/legend/safety.svg';
import iconMapLegendTransit from '../img/icons/map/legend/transit.svg';

/** Tab icon metadata keyed by preset id suffix (program map left nav). */
export const programMapTypes = {
  memorialMap: {
    id: 'Memorial Map',
    icon: iconMapLegendMemorial,
  },
  neighborhoods: {
    id: 'Neighborhoods, Networks, and Zones',
    icon: iconMapLegendInjury,
  },
  projectFeatures: {
    id: 'Project Features',
    icon: iconMapLegendSafety,
  },
  projects: {
    id: 'Projects',
    icon: iconMapLegendProjects,
  },
  transit: {
    id: 'Transit',
    icon: iconMapLegendTransit,
  },
};
